import React, { useState, useEffect } from "react";
import "./FormProvComercializador.css";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

const FormProvComercializador = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;
  const [loader, setLoader] = useState(false);
  const [changeForm, setChangeForm] = useState(false);

  const [User, setUser] = useState({
    nameAndLastName: data.name || "",
    dni: data.cuit ? data.cuit.slice(2, -1) : "",
    cuit: data.cuit || "",
    phone: "",
    email: "",
    placeOfResidence: "",
    postalCode: "",
    street: "",
    numberStreet: "",
    province: "",
    cbu: data.cbu || "",
  });

  useEffect(() => {
    // Verificar si el DNI comienza con 20, 23, 24, 25, 26 o 27
    if (/^(30|33|34)/.test(User.cuit)) {
      setChangeForm(true);
    }
  }, [User.cuit]);

  const validateData = (changeForm) => {
    if (changeForm === false) {
      if (
        User.nameAndLastName.trim() === "" ||
        User.dni.trim() === "" ||
        User.cuit.trim() === "" ||
        User.phone.trim() === "" ||
        User.email.trim() === "" ||
        User.placeOfResidence.trim() === "" ||
        User.postalCode.trim() === "" ||
        User.street.trim() === "" ||
        User.numberStreet.trim() === "" ||
        User.province.trim() === ""
      ) {
        Swal.fire({
          icon: "error",
          title: "Faltan campos!",
          text: "Faltan datos por cargar",
        });
        return false;
      }

      if (User.dni.length !== 8) {
        Swal.fire({
          icon: "error",
          title: "Faltan campos!",
          text: "El DNI debe tener 8 diguitos",
        });
        return false;
      }

      if (User.cbu.length !== 22) {
        Swal.fire({
          icon: "error",
          title: "Faltan campos!",
          text: "El Cbu debe tener 22 diguitos",
        });
        return false;
      }

      return true;
    } else {
      if (
        User.nameAndLastName.trim() === "" ||
        User.cuit.trim() === "" ||
        User.phone.trim() === "" ||
        User.email.trim() === "" ||
        User.placeOfResidence.trim() === "" ||
        User.postalCode.trim() === "" ||
        User.street.trim() === "" ||
        User.numberStreet.trim() === "" ||
        User.province.trim() === ""
      ) {
        Swal.fire({
          icon: "error",
          title: "Faltan campos!",
          text: "Faltan datos por cargar",
        });
        return false;
      }

      if (User.cbu.length !== 22) {
        Swal.fire({
          icon: "error",
          title: "Faltan campos!",
          text: "El Cbu debe tener 22 diguitos",
        });
        return false;
      }

      return true;
    }
  };

  const formdataprov = async () => {
    const isValidData = validateData(changeForm);
    let supp = {};

    if (!isValidData) {
      // Mostrar alerta con SweetAlert u otro método
      return;
    }

    if (/^(30|33|34)/.test(User.cuit)) {
      supp = {
        nameAndLastName: User.nameAndLastName,
        dni: "00000000",
        cuit: User.cuit,
        phone: User.phone,
        email: User.email,
        placeOfResidence: User.placeOfResidence,
        postalCode: User.postalCode,
        street: User.street,
        numberStreet: User.numberStreet,
        province: User.province,
        cbu: User.cbu,
      };
    } else {
      supp = {
        nameAndLastName: User.nameAndLastName,
        dni: User.dni,
        cuit: User.cuit,
        phone: User.phone,
        email: User.email,
        placeOfResidence: User.placeOfResidence,
        postalCode: User.postalCode,
        street: User.street,
        numberStreet: User.numberStreet,
        province: User.province,
        cbu: User.cbu,
      };
    }

    try {
      setLoader(true);

      const id = data.id;

      supp = { ...supp, id };

      const res = await axios.post(
        `${process.env.REACT_APP_COMPLETE_SUPPLIER}`,
        { supp }
      );

      if (res.status === 200) {
        setLoader(false);
        setChangeForm(false);
        navigate("/portal-comercializadores/termscondicionsignature", {
          state: supp,
        });
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const handleNumericInputChange = (fieldName, value) => {
    // Filtrar caracteres no numéricos solo para CUIT, número y código postal
    let numericValue = value;
    if (["cuit", "phone", "postalCode", "numberStreet"].includes(fieldName)) {
      numericValue = value.replace(/[^0-9]/g, "");
    }
    setUser({ ...User, [fieldName]: numericValue });
  };

  return (
    <>
      {changeForm ? (
        <div className="allprov">
          <div className="allformprov">
            <p className="tittleformprv">Ingrese sus datos</p>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Razon social</label>
                <input
                  className="inputupdateProv"
                  type="text"
                  value={User.nameAndLastName || ""}
                  onChange={(e) =>
                    setUser({ ...User, nameAndLastName: e.target.value })
                  }
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprovprofile">Cbu</label>
                <input
                  className="inputupdateProvprofile"
                  maxLength={22}
                  type="text"
                  value={User.cbu || ""}
                  onChange={(e) => setUser({ ...User, cbu: e.target.value })}
                />
              </div>
            </div>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Cuit</label>
                <input
                  className="inputupdateProv"
                  type="number"
                  value={User.cuit || ""}
                  maxLength={11}
                  minLength={11}
                  onChange={(e) =>
                    handleNumericInputChange("cuit", e.target.value)
                  }
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprov">Email</label>
                <input
                  className="inputupdateProv"
                  type="email"
                  value={User.email || ""}
                  onChange={(e) => setUser({ ...User, email: e.target.value })}
                />
              </div>
            </div>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Numero de telefono</label>
                <input
                  className="inputupdateProv"
                  type="number"
                  value={User.phone || ""}
                  onChange={(e) =>
                    handleNumericInputChange("phone", e.target.value)
                  }
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprov">Lugar de residencia</label>
                <input
                  className="inputupdateProv"
                  type="text"
                  value={User.placeOfResidence || ""}
                  onChange={(e) =>
                    setUser({ ...User, placeOfResidence: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Calle</label>
                <input
                  className="inputupdateProv"
                  type="text"
                  value={User.street || ""}
                  onChange={(e) => setUser({ ...User, street: e.target.value })}
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprov">Numero</label>
                <input
                  className="inputupdateProv"
                  type="number"
                  value={User.numberStreet || ""}
                  onChange={(e) =>
                    handleNumericInputChange("numberStreet", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Codigo Postal</label>
                <input
                  className="inputupdateProv"
                  type="number"
                  value={User.postalCode || ""}
                  onChange={(e) =>
                    handleNumericInputChange("postalCode", e.target.value)
                  }
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprov">Provincia</label>
                <select
                  className="inputupdateProv"
                  value={User.province || ""}
                  onChange={(e) =>
                    setUser({ ...User, province: e.target.value })
                  }
                >
                  <option value="">Selecciona una opción</option>
                  <option value="Provincia de Buenos Aires">
                    Provincia de Buenos Aires
                  </option>
                  <option value="Distinto a Provincia de Buenos Aires">
                    Distinto a Provincia de Buenos Aires
                  </option>
                </select>
              </div>
            </div>

            {loader === true ? (
              <div className="loader3"></div>
            ) : (
              <div className="boxprovbutton">
                <button className="buttonprov" onClick={formdataprov}>
                  Siguiente
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="allprov">
          <div className="allformprov">
            <p className="tittleformprv">Ingrese sus datos</p>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Nombre Completo</label>
                <input
                  className="inputupdateProv"
                  type="text"
                  value={User.nameAndLastName || ""}
                  onChange={(e) =>
                    setUser({ ...User, nameAndLastName: e.target.value })
                  }
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprov">DNI</label>
                <input
                  className="inputupdateProv"
                  type="number"
                  value={User.dni || ""}
                  maxLength={8}
                  minLength={8}
                  onChange={(e) => setUser({ ...User, dni: e.target.value })}
                />
              </div>
            </div>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Cuit</label>
                <input
                  className="inputupdateProv"
                  type="number"
                  value={User.cuit || ""}
                  maxLength={11}
                  minLength={11}
                  onChange={(e) =>
                    handleNumericInputChange("cuit", e.target.value)
                  }
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprov">Email</label>
                <input
                  className="inputupdateProv"
                  type="email"
                  value={User.email || ""}
                  onChange={(e) => setUser({ ...User, email: e.target.value })}
                />
              </div>
            </div>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Numero de telefono</label>
                <input
                  className="inputupdateProv"
                  type="number"
                  value={User.phone || ""}
                  onChange={(e) =>
                    handleNumericInputChange("phone", e.target.value)
                  }
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprov">Lugar de residencia</label>
                <input
                  className="inputupdateProv"
                  type="text"
                  value={User.placeOfResidence || ""}
                  onChange={(e) =>
                    setUser({ ...User, placeOfResidence: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Calle</label>
                <input
                  className="inputupdateProv"
                  type="text"
                  value={User.street || ""}
                  onChange={(e) => setUser({ ...User, street: e.target.value })}
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprov">Numero</label>
                <input
                  className="inputupdateProv"
                  type="number"
                  value={User.numberStreet || ""}
                  onChange={(e) =>
                    handleNumericInputChange("numberStreet", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="dosplayinputProv">
              <div className="boxinputprov">
                <label className="labelformprov">Codigo Postal</label>
                <input
                  className="inputupdateProv"
                  type="number"
                  value={User.postalCode || ""}
                  onChange={(e) =>
                    handleNumericInputChange("postalCode", e.target.value)
                  }
                />
              </div>
              <div className="boxinputprov">
                <label className="labelformprov">Provincia</label>
                <select
                  className="inputupdateProv"
                  value={User.province || ""}
                  onChange={(e) =>
                    setUser({ ...User, province: e.target.value })
                  }
                >
                  <option value="">Selecciona una opción</option>
                  <option value="Provincia de Buenos Aires">
                    Provincia de Buenos Aires
                  </option>
                  <option value="Distinto a Provincia de Buenos Aires">
                    Distinto a Provincia de Buenos Aires
                  </option>
                </select>
              </div>
            </div>

            <div
              style={{
                margin: "10px 32px",
                textAlign: "justify",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <label className="labelformprovprofile">Cbu</label>
              <input
                className="inputupdateProvprofile"
                maxLength={22}
                type="text"
                value={User.cbu || ""}
                onChange={(e) => setUser({ ...User, cbu: e.target.value })}
              />
            </div>

            {loader === true ? (
              <div className="loader3"></div>
            ) : (
              <div className="boxprovbutton">
                <button className="buttonprov" onClick={formdataprov}>
                  Siguiente
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FormProvComercializador;
